import { render, staticRenderFns } from "./cms-page-map.vue?vue&type=template&id=74c844b8&scoped=true"
import script from "./cms-page-map.vue?vue&type=script&lang=js"
export * from "./cms-page-map.vue?vue&type=script&lang=js"
import style0 from "./cms-page-map.vue?vue&type=style&index=0&id=74c844b8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74c844b8",
  null
  
)

export default component.exports